import React from "react";
import Dropdown from "react-bootstrap/Dropdown";
import { Link } from "react-router-dom";

export default function HelpButton() {
  return (
    <Dropdown align="end" data-tour="help">
      <Dropdown.Toggle variant="outline-primary" size="sm">
        How it works
      </Dropdown.Toggle>
      <Dropdown.Menu>
        <Dropdown.Item href="/help" target="_blank" rel="noopener noreferrer">
          Open the guide
        </Dropdown.Item>
        <Dropdown.Item href="/help#desktop" target="_blank" rel="noopener noreferrer">
          Coming from the desktop tool
        </Dropdown.Item>
        <Dropdown.Item as={Link} to="/?tour=1">
          Take the tour of this page
        </Dropdown.Item>
      </Dropdown.Menu>
    </Dropdown>
  );
}
